"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iocContainer = exports.lazyMultiInject = exports.lazyInjectTagged = exports.lazyInjectNamed = exports.lazyInject = void 0;
require("reflect-metadata");
var inversify_1 = require("inversify");
var inversify_inject_decorators_1 = require("inversify-inject-decorators");
var TypeDefs_1 = require("./TypeDefs");
var MenuManager_1 = require("./services/impl/MenuManager");
var WidgetsManager_1 = require("./services/impl/WidgetsManager");
var RoutesManager_1 = require("./services/impl/RoutesManager");
var CommandManager_1 = require("./services/impl/CommandManager");
var I18nManager_1 = require("./services/impl/I18nManager");
var UserSettingsLocalStorage_1 = require("./services/impl/UserSettingsLocalStorage");
var JourneyComponentsManager_1 = require("./services/impl/JourneyComponentsManager");
var CacheManager_1 = require("./services/impl/CacheManager");
var DummyLoggerServiceImpl_1 = require("./services/impl/DummyLoggerServiceImpl");
var iocContainer = new inversify_1.Container();
exports.iocContainer = iocContainer;
// Register dependencies
iocContainer.bind(TypeDefs_1.TypeDefs.MenuManager).to(MenuManager_1.MenuManager).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.NavBarManager).to(MenuManager_1.MenuManager).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.WidgetsManager).to(WidgetsManager_1.WidgetsManager).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.RoutesManager).to(RoutesManager_1.RoutesManager).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.CommandManager).toConstantValue(new CommandManager_1.CommandManager(iocContainer));
iocContainer.bind(TypeDefs_1.TypeDefs.I18nManager).to(I18nManager_1.I18nManager).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.JourneyComponentsManager).to(JourneyComponentsManager_1.JourneyComponentsManager).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.UserSettingsStorage).to(UserSettingsLocalStorage_1.UserSettingsLocalStorage).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.CacheService).to(CacheManager_1.CacheManager).inSingletonScope();
iocContainer.bind(TypeDefs_1.TypeDefs.LoggerService).to(DummyLoggerServiceImpl_1.DummyLoggerServiceImpl).inSingletonScope();
// Make additional decorators
var _a = (0, inversify_inject_decorators_1.default)(iocContainer), lazyInject = _a.lazyInject, lazyInjectNamed = _a.lazyInjectNamed, lazyInjectTagged = _a.lazyInjectTagged, lazyMultiInject = _a.lazyMultiInject;
exports.lazyInject = lazyInject;
exports.lazyInjectNamed = lazyInjectNamed;
exports.lazyInjectTagged = lazyInjectTagged;
exports.lazyMultiInject = lazyMultiInject;
//# sourceMappingURL=inversify.config.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/inversify.config.js
// module id = 604
// module chunks = 0